import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { styles } from './Workbench.styles';
import ClaimDetailHeader from '../components/workbench/ClaimDetailHeader';
import EntityTabsContainer from '../components/workbench/EntityTabsContainer';
import { fetchWorkbenchData } from '../services/workbenchDataService';

const WorkbenchClaimDetails = () => {
  const { claimId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [workbenchData, setWorkbenchData] = useState(location.state?.workbenchData || null);
  const [manualTaskId, setManualTaskId] = useState(location.state?.manualTaskId || null);
  const [loading, setLoading] = useState(false);
  console.log(workbenchData, manualTaskId)
  useEffect(() => {
    if (!workbenchData && manualTaskId) {
      const loadWorkbenchData = async () => {
        try {
          setLoading(true);
          const data = await fetchWorkbenchData(manualTaskId);
          setWorkbenchData(data);
        } catch (error) {
          console.error('Error loading workbench data:', error);
        } finally {
          setLoading(false);
        }
      };
      
      loadWorkbenchData();
    }
  }, [workbenchData, manualTaskId]);

  const inDetailEntities = location.state?.inDetailEntities || workbenchData?.inDetailEntities || [];

  if (!workbenchData) {
    return null;
  }

  return (
    <div style={styles.container}>

      {/* Main Content Area */}
      <div style={{...styles.mainContent, margin: '0px auto', width: '90%'}}>
        {/* Claim Detail Header */}
        <ClaimDetailHeader
          dataPoints={workbenchData?.dataPoints}
          sessionState={workbenchData?.sessionState}
        />

        {/* Back Navigation */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          marginTop: '0.5rem',
          marginBottom: '0.5rem'
        }}>
          <button 
            onClick={() => navigate(-1)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem',
              border: 'none',
              color: '#64748b',
              fontSize: '0.95rem',
              cursor: 'pointer',
              padding: '0.3rem 0.5rem',
              borderRadius: '4px',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span style={{ fontSize: '1.2rem', display: 'inline-block', width: '25px', height: '25px', backgroundColor: '#64748b !important', color: '#64748b', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '0.5rem' }}>‹</span>
            <span style={{ fontWeight: '500' }}>Claim Details</span>
          </button>
          <span style={{ color: '#cbd5e1', margin: '0 0.3rem' }}>|</span>
          <span style={{ color: '#94a3b8', fontSize: '0.9rem' }}>
            Claim ID: {claimId}
          </span>
        </div>
        {/* Entity Tabs with Dynamic Forms */}
        <EntityTabsContainer claimId={claimId} inDetailEntities={inDetailEntities} />
      </div>
    </div>
  );
};

export default WorkbenchClaimDetails;
